import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchPrescriptions } from "../../features/prescription/prescriptionSlice";
import Spinner from "react-bootstrap/Spinner"; // Bootstrap spinner for loading

const Prescription = () => {
   
  const dispatch = useDispatch();

  // Extracting the relevant parts of the prescription state
  const { prescriptions, loading, error, totalPages, currentPage, totalItems } =
    useSelector((state) => state.prescriptions);

  const userId = useSelector((state) => state.feature1?.userId);
  const [page, setPage] = useState(1); // Keep track of the current page

  useEffect(() => {
    if (userId) {
      dispatch(fetchPrescriptions({ userId, page })); // Fetch prescriptions based on the current page
    }
  }, [dispatch, userId, page]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  if (loading) {
    return (
      <div className="loader-container">
        <Spinner animation="border" role="status">
          <span className="sr-only"></span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return <p>Error: {error}</p>;
  }

  return (
    <div className="container clear my-orders">
      {prescriptions?.data?.length > 0 ? (
        <div>
          <h3 className="manage-profile-heading">
            Prescriptions: {totalItems}
          </h3>
          <div className="prescriptions-list">
            <div className="row">
              {prescriptions.data.map((prescription) => (
                <div
                  key={prescription._id}
                  className="prescription-card col-sm-4"
                >
                  <h5 className="col-sm-3">
                    Prescription ID: {prescription._id}
                  </h5>
                  <p>Status: {prescription.status}</p>

                  {/* Display the image instead of the URL */}
                  <img
                    src={prescription.url}
                    alt={`Prescription ${prescription._id}`}
                    // style={{ width: "100%", height: "auto" }}
                    className="img-fluid"
                  />

                  {/* <p>
                    Created At:{" "}
                    {new Date(prescription.createdAt).toLocaleString()}
                  </p> */}
                  <p>
                    Updated At:{" "}
                    {new Date(prescription.updatedAt).toLocaleString()}
                  </p>
                  {/* <p>User ID: {prescription.user_id}</p> */}
                  {/* <p>Is Deleted: {prescription.isDeleted ? "Yes" : "No"}</p> */}
                </div>
              ))}
            </div>
          </div>
          {/* Pagination Controls */}
          <div className="col-auto">
            <nav aria-label="Page navigation">
              <ul className="pagination justify-content-end mb-0">
                <li
                  className={`page-item ${currentPage <= 1 ? "disabled" : ""}`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage <= 1}
                  >
                    Previous
                  </button>
                </li>
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i + 1}
                    className={`page-item ${
                      currentPage === i + 1 ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(i + 1)}
                    >
                      {i + 1}
                    </button>
                  </li>
                ))}
                <li
                  className={`page-item ${
                    currentPage >= totalPages ? "disabled" : ""
                  }`}
                >
                  <button
                    className="page-link"
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage >= totalPages}
                  >
                    Next
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      ) : (
        <p>No prescriptions available</p>
      )}
    </div>
  );
};

export default Prescription;
